const STORAGE_KEY = 'mega_recent_enrollments';
const WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const getEnrollments = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

const saveEnrollments = (entries) => {
  const cutoff = Date.now() - 30 * 24 * 60 * 60 * 1000;
  const pruned = entries.filter((e) => new Date(e.enrolledAt).getTime() >= cutoff);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pruned));
};

export const recordEnrollment = (courseId) => {
  const entries = getEnrollments().filter((e) => String(e.courseId) !== String(courseId));
  entries.push({ courseId: String(courseId), enrolledAt: new Date().toISOString() });
  saveEnrollments(entries);
};

export const isWithinThisWeek = (dateStr) => {
  if (!dateStr) return false;
  const date = new Date(dateStr);
  if (Number.isNaN(date.getTime())) return false;
  return Date.now() - date.getTime() <= WEEK_MS;
};

export const getCourseEnrollmentDate = (course) =>
  course?.assignedAt ??
  course?.enrolledAt ??
  course?.assignmentDate ??
  course?.enrolledDate ??
  course?.assignedDate ??
  null;

export const getThisWeekEnrollmentIds = () => {
  const weekAgo = Date.now() - WEEK_MS;
  return new Set(
    getEnrollments()
      .filter((e) => new Date(e.enrolledAt).getTime() >= weekAgo)
      .map((e) => String(e.courseId))
  );
};

export const isCourseEnrolledThisWeek = (course) => {
  const localIds = getThisWeekEnrollmentIds();
  if (localIds.has(String(course.id))) return true;

  const apiDate = getCourseEnrollmentDate(course);
  return isWithinThisWeek(apiDate);
};

export const countThisWeekEnrollments = (userCourses = []) => {
  const ids = new Set(getThisWeekEnrollmentIds());

  userCourses.forEach((course) => {
    if (isCourseEnrolledThisWeek(course)) {
      ids.add(String(course.id));
    }
  });

  return ids.size;
};

export const getThisWeekEnrollmentCount = () => getThisWeekEnrollmentIds().size;
